import * as React from "react";
import MuiInfoIcon from "@mui/icons-material/Info";
import MuiInfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

interface Props {
  tooltip: string;
  size?: "small" | "medium" | "large";
  variant?: "contained" | "outlined";
}

const InfoIcon: React.FC<Props> = ({ tooltip, size, variant = "contained" }) => (
  <Tooltip title={<Typography variant="body2">{tooltip}</Typography>} placement="top" arrow={true}>
    {variant === "contained" ? (
      <MuiInfoIcon color="info" fontSize={size} cursor="pointer" />
    ) : (
      <MuiInfoOutlinedIcon color="info" fontSize={size} cursor="pointer" />
    )}
  </Tooltip>
);

export { InfoIcon };
